import React, { memo, useRef, useEffect } from 'react';

const RowComponent = memo(({ index, style, ariaAttributes, data, setHeight, renderRow }) => {
    const rowRef = useRef();
    const hasSetHeight = useRef(false);

    useEffect(() => {
        if (hasSetHeight.current) return;
        if (!rowRef?.current?.firstElementChild) return;

        const height = rowRef.current.firstElementChild.getBoundingClientRect().height;
        if (height > 0) {
            setHeight(index, height);
            hasSetHeight.current = true;
        }
    }, [setHeight, index]);

    if (!data || !data[index]) return null;

    return (
        <div ref={rowRef} style={style} {...ariaAttributes}>
            {renderRow({ index, data: data[index] })}
        </div>
    );
});

export default RowComponent;
